<template>
  <div class="joins-wrap">
    <section>
      <div class="joins-banner">
        <img :src="bannerLink" />
      </div>
    </section>
<!--    <section class="talent-concept ptb-80" id="recruitment">-->
<!--      <div class="total-width">-->
<!--        <h1 class="joins-title">{{ talentConcept.title }}</h1>-->
<!--        <h1 class="joins-subtitle mt-81">{{ talentConcept.subtitle }}</h1>-->
<!--        <img class="talent-concept__img" :src="talentConcept.imgSrc" />-->
<!--      </div>-->
<!--    </section>-->
<!--    <section class="talent-portrait ptb-80">-->
<!--      <div class="joins-subtitle c-w">{{ talentPortrait.subtitle }}</div>-->
<!--      <div class="portraits">-->
<!--        <div-->
<!--          v-for="(item, index) in talentPortrait.portraits"-->
<!--          :key="index"-->
<!--          class="portrait-item"-->
<!--        >-->
<!--          <div class="item__img">-->
<!--            <img :src="item.img" />-->
<!--          </div>-->
<!--          <div class="item-content">-->
<!--            <div class="item-content__title">{{ item.title }}</div>-->
<!--            <div class="item-content__subtitle">{{ item.subtitle }}</div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->
<!--    <section class="talent-development ptb-80">-->
<!--      <h1 class="joins-subtitle">{{ talentDevelopment.subtitle }}</h1>-->
<!--      <div class="developments">-->
<!--        <div-->
<!--          class="developments-item"-->
<!--          v-for="(item, index) in talentDevelopment.developments"-->
<!--          :key="index"-->
<!--        >-->
<!--          <img :src="item.img" />-->
<!--          <div-->
<!--            class="developments-item__content"-->
<!--            :class="[index % 2 === 0 ? 'odd-content' : 'even-content']"-->
<!--          >-->
<!--            <h3>{{ item.title }}</h3>-->
<!--            <div>{{ item.subtitle }}</div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->
    <section class="kk-recruitment ptb-80" id="concept">
      <h1 class="total-width joins-title">{{ kkRecruitment.title }}</h1>
      <swiper ref="mySwiper" class="swiper" :options="swiperOptions">
        <swiper-slide v-for="(card, index) in kkRecruitment.cards" :key="index">
          <img width="100%" :src="card.img" />
        </swiper-slide>
      </swiper>
      <div class="kk-recruitment__content">
        <div class="pagination">
          <div
            :class="{ 'active-bullet': index === activeInfoIndex }"
            class="bullet"
            v-for="(card, index) in kkRecruitment.cards"
            :key="index"
            @click="clickSwiper(index)"
          >
            <h3>{{ card.title }}</h3>
            <div>{{ card.des }}</div>
          </div>
        </div>
        <div class="info">
          <div class="header">
            <h2>{{ kkRecruitment.recruitments.title }}</h2>
            <span>{{ kkRecruitment.recruitments.des }}</span>
          </div>
          <table>
            <thead>
              <tr>
                <td
                  v-for="cloumn in kkRecruitment.recruitments.cloumns"
                  :key="cloumn.prop"
                  :style="{ width: cloumn.width }"
                >
                  {{ cloumn.label }}
                </td>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in recruit.list"
                :key="item.id || index"
                @click="handleClick(item)"
              >
                <td>
                  <p>{{ item.workAddress }}</p>
                </td>
                <td>
                  <p>{{ item.jobName }}</p>
                </td>
                <td>
                  <p>{{ item.department }}</p>
                </td>
                <td>
                  <p>{{ item.jobCategory }}</p>
                </td>
                <td>
                  <p>{{ item.educationName }}</p>
                </td>
                <td>{{ item.minSalary }}-{{ item.maxSalary }}k</td>
              </tr>
            </tbody>
          </table>
          <div class="info-footer">
            <pagination :num="recruit.count" @page="handlePage"></pagination>
          </div>
        </div>
        <div
          class="kk-button"
          @click="location(kkRecruitment.recruitments.url)"
        >
          <p>查看全部招聘信息</p>
          <img src="@/assets/images/index/arrow_r_blak.webp" alt="" />
        </div>
      </div>
    </section>
    <section class="contact-us pt-80" id="contact">
      <div class="total-width">
        <h1 class="joins-title">{{ contactUs.title }}</h1>
        <div class="contact-us-content">
          <img :src="contactUs.logo" />
          <div class="company-info fuk">
            <div
              class="info"
              v-for="(info, index) in contactUs.companyInfo"
              :key="index"
            >
              <img :src="info.iconUrl" />
              <ul>
                <li
                  class="info-item"
                  v-for="(item, i) in info.infos"
                  :key="index + i"
                >
                  {{ item.label }}
                  <span>{{ item.value }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
let vm = null
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { joinsData } from '@/common/util/data.js'
import { getRecentRecruitment } from '@/api/joins'

import Pagination from '../../components/Pagination.vue'
export default {
  name: 'Index',
  components: { swiper, swiperSlide, Pagination },
  data() {
    return {
      ...joinsData,
      activeInfoIndex: 0,
      swiperOptions: {
        loop: true,
        speed: 1000,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        observer: true,
        ovserveParents: true,
        on: {
          slideChangeTransitionStart: function () {
            vm.activeInfoIndex =
              (this.activeIndex > 2 ? 1 : this.activeIndex) - 1
          },
        },
      },
      recruit: {
        count: 10,
        list: [],
      },
      pages: {
        page: 1,
        pageSize: 10,
      },
    }
  },
  methods: {
    clickSwiper(index) {
      this.$refs['mySwiper'].swiper.slideToLoop(index)
    },
    location(url) {
      window.open(url)
    },
    handleClick(item) {
      this.$router.push(`/joins/${item.id}`)
    },
    // 获取分页信息
    handlePage(page) {
      this.pages.page = page
      this.getRecentRecruitmentList(this.pages)
    },
    // 获取近期招聘列表
    async getRecentRecruitmentList(pages) {
      const { data } = await getRecentRecruitment(pages)
      this.recruit = data
    },
  },
  computed: {
    activeCard() {
      return this.kkRecruitment.cards[this.kkRecruitment.activeIndex]
    },
  },
  created() {
    vm = this
    this.getRecentRecruitmentList(this.pages)
  },
  destroyed() {
    vm = null
  },
}
</script>
<style scoped lang="less">
.c-w {
  color: #fff !important;
}

.ptb-80 {
  padding: 80px 0;
}

.mt-81 {
  margin-top: 81px;
}

img {
  display: block;
}

.joins-title {
  font-size: 40px;
  text-align: left;
}

.joins-subtitle {
  font-size: 32px;
  text-align: center;
  font-weight: bold;
}

.joins-wrap {
  color: #333;

  .joins-banner {
    > img {
      width: 100%;
      height: auto;
      object-fit: cover;
    }
  }

  .talent-concept {
    background-image: url('../../assets/images/joins/talent-concept-bg.png');
    background-size: cover;
    background-repeat: no-repeat;

    &__img {
      margin: 40px auto 80px auto;
      width: 67.7%;
      height: 33.3%;
    }
  }

  .talent-portrait {
    background-image: url('../../assets/images/joins/talent-portrait-bg.png');
    background-size: cover;
    background-repeat: no-repeat;
    padding-bottom: 132px;
    text-align: center;

    .portraits {
      margin-top: 87px;
      display: inline-flex;
      justify-content: space-between;
      margin-right: -26px;

      .portrait-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-right: 26px;
        width: 280px;
        height: 364px;
        background: rgba(255, 255, 255, 0.9);
        box-shadow: 0px 14px 14px 0px rgba(0, 0, 0, 0.07);
        border-radius: 8px;
        border: 1px solid #ffffff;
        overflow: hidden;

        &:hover {
          box-shadow: 2px 2px 6px rgba(153, 153, 153, 0.3);
          transform: scale(1.06);
        }

        .item__img {
          flex: 1;
          background: #fff;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 120px;
          }
        }

        .item-content {
          height: 138px;
          padding: 17px 0;
          text-align: center;

          &__title {
            position: relative;
            margin-bottom: 15px;
            height: 41px;
            font-size: 24px;
            font-weight: 600;
            color: #000000;
            line-height: 32px;
          }

          &__title::after {
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            content: '';
            width: 30px;
            height: 4px;
            background: #fb4242;
            border-radius: 3px 0px 3px 0px;
          }

          &__subtitle {
            padding: 0 74px;
            height: 48px;
            font-size: 13px;
            font-weight: 400;
            color: #333333;
            line-height: 24px;
          }
        }
      }
    }
  }

  .talent-development {
    background-image: url('../../assets/images/joins/development-bg.png');
    background-size: cover;
    background-repeat: no-repeat;

    .developments {
      margin: 0 auto;
      margin-top: 80px;
      width: 62.5%;
      border-radius: 5px;
      display: flex;

      .developments-item {
        position: relative;
        overflow: hidden;

        img {
          width: 100%;
          object-fit: cover;
        }

        &__content {
          padding: 0 44px;
          position: absolute;
          width: 100%;
          height: 68.07%;
          z-index: 20;
          left: 0;
          box-shadow: 0px 14px 14px 0px rgba(0, 0, 0, 0.07);
          backdrop-filter: blur(24.63202445332707px);
          font-size: 28px;
          font-weight: 600;

          // &:hover {
          //   background: rgba(205, 51, 36, 0.7) !important;
          //   div {
          //     opacity: 1;
          //   }
          // }
          h3 {
            position: absolute;
            height: 37px;
          }

          h3::after {
            position: absolute;
            bottom: -13px;
            left: 0;
            content: '';
            width: 30px;
            height: 4px;
            background: #fb4242;
            border-radius: 3px 0px 3px 0px;
          }

          div {
            position: absolute;
            font-size: 16px;
            opacity: 0;
          }
        }

        .odd-content {
          color: #fff;
          background: rgba(0, 0, 0, 60%);
          top: 61.54%;

          // transition: top 1s;
          // &:hover {
          //   top: 31.9%;
          // }
          h3 {
            top: 26%;
          }

          // div {
          //   top: 68%;
          // }
        }

        .even-content {
          color: #333;
          background: rgba(255, 255, 255, 0.8);
          bottom: 61.54%;
          transition: bottom 1s;

          h3 {
            bottom: 26%;
          }

          // div {
          //   bottom: 68%;
          // }
          // &:hover {
          //   color: #fff;
          //   bottom: 31.9%;
          // }
        }
      }
    }
  }

  .kk-recruitment {
    background: #f9f9f9;
    overflow: hidden;

    .swiper {
      margin-top: 60px;
    }

    &__content {
      color: #333333;
      position: relative;
      left: 50%;
      top: -90px;
      width: 75%;
      z-index: 98;
      border-radius: 5px;
      transform: translateX(-50%);
      overflow: hidden;

      .pagination {
        height: 180px;
        background-color: #ffffff;
        border-radius: 5px;
        overflow: hidden;
        display: flex;
        justify-content: space-between;
        text-align: left;
        position: relative;

        &::after {
          position: absolute;
          background: #eeeeee;
          content: '';
          width: 1px;
          height: 60%;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }

        .bullet {
          cursor: pointer;
          flex: 1;
          padding: 40px 100px;
          box-sizing: border-box;

          h3 {
            font-size: 32px;
            color: #333333;
          }

          div {
            margin-top: 20px;
            font-size: 18px;
            color: #666666;
          }
        }

        .active-bullet {
          h3 {
            color: #cd3324;
          }
        }
      }

      .info {
        background-color: #fff;
        margin-top: 20px;
        padding: 80px 100px 100px;
        border-radius: 5px;

        .header {
          display: flex;
          align-items: center;

          > h2 {
            font-size: 32px;
          }

          > span {
            padding: 0 10px;
            margin-left: 20px;
            color: #cd3324;
            background: rgba(205, 51, 36, 0.05);
            border-radius: 5px;
            height: 32px;
            line-height: 34px;
          }
        }

        table,
        thead,
        tbody,
        tr {
          display: block;
        }

        table {
          margin-top: 40px;
          font-size: 16px;
          display: block;
          max-height: 990px;

          tr {
            display: flex;
            justify-content: space-between;
            height: 80px;
            line-height: 80px;
            cursor: pointer;
          }

          thead {
            color: #999999;

            tr {
              td:last-child {
                flex: 0 0 auto;
                min-width: 162px;
              }
            }
          }

          tbody {
            color: #333333;
            font-weight: 500;
          }

          tbody tr {
            border: 1px solid #f1f1f1;
            border-radius: 5px;
            margin-bottom: 10px;

            &:hover {
              color: #cd3324;
              box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
            }

            & td:nth-last-child(1) {
              color: #cd3324;
              flex: 0 0 auto;
              min-width: 160px;
            }

            td {
              p {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }

          td {
            flex: 1;
            padding-left: 40px;
            overflow: hidden;
          }
        }

        &-footer {
          padding-top: 40px;
        }
      }

      .kk-button {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 80px;
        background: #ffffff;
        border-radius: 5px;
        cursor: pointer;

        p {
          font-size: 18px;
          font-weight: 400;
        }

        img {
          width: 20px;
          height: 20px;
        }
      }
    }
  }

  .contact-us {
    background-image: url('../../assets/images/joins/join-bg.png');
    background-size: cover;
    background-repeat: no-repeat;
    position: relative;
    height: 494px;

    &-content {
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 0;
      display: flex;
      justify-content: center;

      > img {
        width: auto;
        height: 298px;
      }

      .company-info {
        display: flex;
        flex-direction: column;
        margin-left: 92px;
        padding: 51px 0 0 40px;
        width: 37.81%;
        min-width: 606px;
        height: 260px;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 5px;
        margin-bottom: -11px;

        .info {
          margin-bottom: 11px;
          display: flex;
          font-size: 16px;

          img {
            width: 28px;
            height: 28px;
          }

          &-item {
            margin-left: 11px;
            padding: 6px 0;
            overflow: hidden;

            span {
              font-weight: bold;
            }
          }
        }
      }
    }
  }
}
</style>
<style>
.content-info-list::-webkit-scrollbar {
  width: 4px;
  border-radius: 2px;
}

.content-info-list::-webkit-scrollbar-thumb {
  width: 4px;
  background: #f0f0f3;
  border-radius: 2px;
}

.fuk {
  padding: 40px 0 0 10px !important;
  .info {
    font-size: 15px !important;
  }
}

@media screen and (min-width: 1920px) {
  .fuk {
    padding: 51px 0 0 40px !important;
    .info {
      font-size: 16px !important;
    }
  }
}

</style>
